var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "width": "1px",
      "height": "1px",
      "overflow": "hidden"
    }
  }, [_c('img', {
    attrs: {
      "id": "croppr-image"
    }
  })]);
}]

export { render, staticRenderFns }